import { NumberInput, NumberInputProps, createStyles } from "@mantine/core";
import React, { useRef } from "react";
import { IFocusableFormField } from "@type";

const useStyles = createStyles((theme) => ({
  icon: {
    backgroundColor: "#e9ecef",
    color: "#495057",
    padding: "0.375rem 0.75rem",
    margin: "1px",
    width: "55px",
  },
}));

export interface IFormMoneyInputProps<Values = Record<string, unknown>>
  extends NumberInputProps,
    IFocusableFormField<Values> {}

export const FormMoneyInput: <Values = Record<string, unknown>>(
  props: IFormMoneyInputProps<Values>,
) => JSX.Element = ({ fieldName, parentForm, ...rest }) => {
  const { classes } = useStyles();
  const elementRef = useRef<HTMLInputElement>(null);
  parentForm.registerField(fieldName, elementRef);

  const inputProps = parentForm.getInputProps(fieldName);
  const inputOnChange = inputProps.onChange;
  inputProps.onChange = (value: any) =>
    inputOnChange(value === "" ? null : value);
  if (!inputProps.value && inputProps.value !== 0) {
    inputProps.value = "";
  }

  return (
    <NumberInput
      {...inputProps}
      {...rest}
      ref={elementRef}
      icon="AUD"
      iconWidth={60}
      step={0.01}
      precision={2}
      parser={(value: any) => value.replace(/\$\s?|(,*)/g, "")}
      formatter={(value: any) =>
        !Number.isNaN(parseFloat(value))
          ? `$ ${value}`.replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")
          : "$ "
      }
      classNames={{
        icon: classes.icon,
      }}
    />
  );
};
